import { cn } from '@/utils/tailwind';

import { CELL_PADDING } from '../../DatasetSessionCompare.utils';
import { DEFAULT_COLUMN_WIDTHS } from '../../constants';
import { isInPlayground } from '../../utils/isInPlayground';
import { DatasetResizeHandle } from '../DatasetCompareColumnResizer';

export const ExperimentColumnHeader = ({
  columnIndex,
  columnName,
  tableHeight,
  columnWidthStorage,
  setColumnWidthStorage,
  children,
  minColumnWidth,
  className,
  isTable = true,
  allowResize = true,
}: {
  columnIndex: number;
  columnName: string;
  tableHeight: number;
  columnWidthStorage: number[];
  setColumnWidthStorage: (fromPrev: (prev: number[]) => number[]) => void;
  children: React.ReactNode;
  minColumnWidth?: number;
  className?: string;
  columnIndices?: number[];
  isTable?: boolean;
  allowResize?: boolean;
}) => {
  const Element = isTable ? 'th' : 'div';
  const inPlayground = isInPlayground();

  const width =
    columnWidthStorage[columnIndex] ?? minColumnWidth ?? DEFAULT_COLUMN_WIDTHS;
  return (
    <Element
      key={`${columnName}-column-header`}
      className={cn(
        'sticky top-0 overflow-hidden whitespace-nowrap border-y border-secondary bg-secondary text-left align-top text-sm font-semibold capitalize',
        className
      )}
      data-column={columnIndex}
      style={{
        ...CELL_PADDING(inPlayground ? 'lg' : 'sm'),
        paddingTop: '8px',
        paddingBottom: '8px',
        width,
        maxWidth: width,
        minWidth: width,
      }}
    >
      {children}
      {allowResize && (
        <DatasetResizeHandle
          columnIdx={columnIndex}
          tableHeight={tableHeight}
          setColumnWidthStorage={setColumnWidthStorage}
          minColumnWidth={minColumnWidth}
        />
      )}
    </Element>
  );
};
